$(document).on('turbolinks:load', function() {
  var $titleList = $('#title-list');
  if ($titleList.length === 0) return;

  var labelsText = $('#title-labels-data').text();
  var descriptionsText = $('#title-descriptions-data').text();
  if (!labelsText || !descriptionsText) return;
  var titleLabels = JSON.parse(labelsText);
  var titleDescriptions = JSON.parse(descriptionsText);
  var $modalOverlay = $('#title-modal-overlay');

  // =============================
  // ドラッグ&ドロップ
  // =============================
  var dragItem = null;

  // タッチイベント用の変数
  var touchDragItem = null;
  var touchTimeout = null;
  var isDragging = false;

  function initDragEvents($item) {
    var el = $item[0];

    // --- マウス（HTML5 Drag and Drop） ---
    el.addEventListener('dragstart', function() {
      dragItem = el;
      setTimeout(function() { el.style.opacity = '0.4'; }, 0);
    });

    el.addEventListener('dragend', function() {
      el.style.opacity = '1';
      dragItem = null;
      // ドラッグ中クラスを全て除去
      $titleList.find('.title-item').removeClass('drag-over');
    });

    el.addEventListener('dragover', function(e) {
      e.preventDefault();
      if (dragItem === el) return;
      var rect = el.getBoundingClientRect();
      var midY = rect.top + rect.height / 2;
      if (e.clientY < midY) {
        $titleList[0].insertBefore(dragItem, el);
      } else {
        $titleList[0].insertBefore(dragItem, el.nextSibling);
      }
    });

    // --- タッチ（モバイル対応） ---
    el.addEventListener('touchstart', function(e) {
      // 削除ボタンタップ時はデフォルト動作を許可
      if (e.target.closest('.title-remove')) return;
      e.preventDefault();
      var touch = e.touches[0];
      var self = this;
      touchTimeout = setTimeout(function() {
        isDragging = true;
        touchDragItem = self;
        self.style.opacity = '0.4';
      }, 150);
    }, { passive: false });

    el.addEventListener('touchmove', function(e) {
      if (!isDragging || !touchDragItem) {
        // ドラッグ開始前に動いた場合はキャンセル（通常スクロールを許可）
        if (touchTimeout) {
          clearTimeout(touchTimeout);
          touchTimeout = null;
        }
        return;
      }
      e.preventDefault();
      var touch = e.touches[0];
      var target = document.elementFromPoint(touch.clientX, touch.clientY);
      if (!target) return;
      var targetItem = target.closest('.title-item');
      if (!targetItem || targetItem === touchDragItem) return;
      var rect = targetItem.getBoundingClientRect();
      var midY = rect.top + rect.height / 2;
      if (touch.clientY < midY) {
        $titleList[0].insertBefore(touchDragItem, targetItem);
      } else {
        $titleList[0].insertBefore(touchDragItem, targetItem.nextSibling);
      }
    }, { passive: false });

    el.addEventListener('touchend', function() {
      if (touchTimeout) {
        clearTimeout(touchTimeout);
        touchTimeout = null;
      }
      if (touchDragItem) {
        touchDragItem.style.opacity = '1';
      }
      touchDragItem = null;
      isDragging = false;
    });
  }

  // 既存アイテムにドラッグイベントを設定
  $titleList.find('.title-item').each(function() {
    initDragEvents($(this));
  });

  // =============================
  // 対戦形式変更時の非互換タイトル除去
  // =============================
  var sanmaIncompatible = ['rentai_rate', 'north_king'];

  $('input[name="league[play_type]"]').on('change', function() {
    var playType = parseInt($(this).val());
    if (playType === 3) {
      sanmaIncompatible.forEach(function(type) {
        $titleList.find('.title-item[data-title-type="' + type + '"]').remove();
        $modalOverlay.find('.title-modal-item[data-title-type="' + type + '"]').hide();
      });
    } else {
      sanmaIncompatible.forEach(function(type) {
        $modalOverlay.find('.title-modal-item[data-title-type="' + type + '"]').show();
      });
    }
  });

  // =============================
  // チップ成績反映切替時の非互換タイトル除去
  // =============================
  var tipInvalidIncompatible = ['most_chips'];

  $('input[name="league[is_tip_valid]"]').on('change', function() {
    var isTipValid = $(this).val() === 'true';
    if (isTipValid) {
      tipInvalidIncompatible.forEach(function(type) {
        $modalOverlay.find('.title-modal-item[data-title-type="' + type + '"]').show();
      });
    } else {
      tipInvalidIncompatible.forEach(function(type) {
        $titleList.find('.title-item[data-title-type="' + type + '"]').remove();
        $modalOverlay.find('.title-modal-item[data-title-type="' + type + '"]').hide();
      });
    }
  });

  // =============================
  // モーダル開閉
  // =============================
  function updateModalState() {
    var addedTypes = [];
    $titleList.find('.title-item').each(function() {
      addedTypes.push($(this).data('titleType'));
    });

    $modalOverlay.find('.title-modal-item').each(function() {
      var $item = $(this);
      var type = $item.data('titleType');
      if (addedTypes.indexOf(type) !== -1) {
        $item.addClass('selected already-added');
        $item.find('.title-modal-item-check').text('✓');
      } else {
        $item.removeClass('selected already-added');
        $item.find('.title-modal-item-check').text('');
      }
    });
  }

  // モーダルを開く
  $('#add-title-btn').on('click', function() {
    updateModalState();
    $modalOverlay.addClass('active');
  });

  // モーダルを閉じる
  $modalOverlay.on('click', function(e) {
    if ($(e.target).is($modalOverlay) || $(e.target).hasClass('js-title-modal-cancel')) {
      $modalOverlay.removeClass('active');
    }
  });

  $modalOverlay.find('.js-title-modal-cancel').on('click', function() {
    $modalOverlay.removeClass('active');
  });

  // =============================
  // モーダルからタイトル選択（トグル）
  // =============================
  $('.title-modal-sheet').on('click', '.title-modal-item', function() {
    var $item = $(this);
    // 既にリストに追加済みのアイテムはトグル不可
    if ($item.hasClass('already-added')) return;

    $item.toggleClass('selected');
    if ($item.hasClass('selected')) {
      $item.find('.title-modal-item-check').text('✓');
    } else {
      $item.find('.title-modal-item-check').text('');
    }
  });

  // 「追加」ボタン: 新たに選択されたタイトルを一括追加
  $('.title-modal-sheet').on('click', '.js-title-modal-submit', function() {
    $modalOverlay.find('.title-modal-item.selected:not(.already-added)').each(function() {
      var $item = $(this);
      var type = $item.data('titleType');
      var label = titleLabels[type] || type;
      var desc = titleDescriptions[type] || '';

      var $newItem = $('<div class="title-item" draggable="true">')
        .attr('data-title-type', type)
        .append('<span class="title-drag-handle">☰</span>')
        .append(
          '<div class="title-info">' +
            '<span class="title-name">' + label + '</span>' +
            '<span class="title-desc">' + desc + '</span>' +
          '</div>'
        )
        .append('<input type="hidden" name="title_types[]" value="' + type + '">')
        .append('<button type="button" class="title-remove">✕</button>');

      $titleList.append($newItem);
      initDragEvents($newItem);
    });

    $modalOverlay.removeClass('active');
  });

  // =============================
  // 削除
  // =============================
  $titleList.on('click', '.title-remove', function() {
    var $item = $(this).closest('.title-item');
    $item.css({
      transition: 'opacity 0.2s, transform 0.2s',
      opacity: '0',
      transform: 'translateX(20px)'
    });
    setTimeout(function() { $item.remove(); }, 200);
  });
});
